import Model from "@/models/Model";
import Like from "@/models/Like";
import Assignee from "@/models/Assignee";
import Rating from "@/models/Rating";
import Report from "@/models/Report";
export default class Resource extends Model {
    resource() {
        return "resources";
    }

    baseURL() {
        return super.baseURL() + "/resourcecenter";
    }

    created_by() {
        return this.related?.user?.display_name ?? "";
    }

    created_date() {
        let date = new Date(this.created_at.date ?? this.created_at);
        return date.toLocaleDateString();
    }

    updated_date() {
        let date = new Date(this.updated_at.date ?? this.updated_at);
        return date.toLocaleDateString();
    }

    thumbnail() {
        return this?.thumbUrl ?? this?.related?.thumbnail?.thumbnail_url;
    }

    thumbnailalt() {
        return this.title;
    }

    isLiked() {
        return this.related?.userlikes?.length > 0;
    }

    assignees() {
        return this.hasMany(Assignee);
    }

    ratings() {
        return this.hasMany(Rating);
    }

    reports() {
        return this.hasMany(Report);
    }

    resourcelikes() {
        return this.hasMany(Like);
    }

    async addLike() {
        const like = new Like({}).for(this);
        return await like.save();
    }

    async removeLike(like) {
        const toDel = new Like({ id: like.id }).for(this);
        return await toDel.delete();
    }
}
